import type { RouteLocation } from 'vue-router';

export default function useAuth() {
    const { isFeatureEnabled } = useFeatureFlags();
    const { $keycloak } = useNuxtApp();
    const { locale } = useNuxtApp().$i18n;

    /**
     *
     */
    const isKeycloakInitialized = computed(() => $keycloak?.didInitialize ?? false);

    /**
     *
     */
    const isAuthenticated = computed(() => $keycloak?.authenticated ?? false);

    /**
     *
     */
    async function getAccountURL() {
        return await $keycloak?.createLoginUrl?.({ action: 'UPDATE_PROFILE', locale: locale.value }) ?? '';
    }

    /**
     *
     */
    async function getPasswordURL() {
        return await $keycloak?.createLoginUrl?.({ action: 'UPDATE_PASSWORD', locale: locale.value }) ?? '';
    }

    /**
     *
     */
    async function getToptURL() {
        return await $keycloak?.createLoginUrl?.({ action: 'CONFIGURE_TOTP', locale: locale.value }) ?? '';
    }

    /**
     *
     * @param origin
     * @param fullPath
     */
    function createKeycloakRedirectUri(origin: string, fullPath: string): string {
        const redirectUri = new URL('/', origin);

        // URLSearchParams performs the required nested percent-encoding.
        redirectUri.searchParams.set('redirect', fullPath);

        return redirectUri.toString();
    }

    /**
     *
     */
    const isSocialLogin = computed(() => {
        const token = $keycloak?.tokenParsed;
        return token?.idp !== undefined;
    });

    /**
     *
     */
    function login(routeParam?: RouteLocation) {
        if (!isFeatureEnabled('login')) {
            return false;
        }

        const { origin } = useRequestURL();
        const { fullPath, hash } = routeParam ?? useRoute();
        const redirectUri = createKeycloakRedirectUri(origin, fullPath.replace(hash, ''));

        return $keycloak?.login({
            redirectUri: redirectUri.toString(),
            locale: locale.value,
        });
    };

    /**
     *
     */
    function logout(routeParam?: RouteLocation) {
        const { origin } = useRequestURL();
        const { fullPath, hash } = routeParam ?? useRoute();
        const redirectUri = createKeycloakRedirectUri(origin, fullPath.replace(hash, ''));

        $keycloak?.logout({
            redirectUri: redirectUri.toString(),
        });
    };

    return {
        isKeycloakInitialized,
        isSocialLogin,
        isAuthenticated,
        createKeycloakRedirectUri,
        login,
        logout,
        getAccountURL,
        getPasswordURL,
        getToptURL,
    };
}
